import Link from 'next/link';

/**
 * Compact methodology/trust line rendered above the ranked forwarder list.
 *
 * Deliberately a <p>, not a heading: the 2026 Growth Memo listicle study found
 * extra section headings correlate with WORSE rankings, while an author/about
 * link correlates with top-3 placement. Keep this element heading-free.
 */
export function RankingsAttribution() {
  return (
    <p
      className="rankings-attribution"
      style={{ fontSize: '0.85rem', opacity: 0.85, margin: '0 0 1rem' }}
    >
      Rankings by Shipzy, based on measured RFQ response times, quote quality, and peer
      endorsements — not paid placement.{' '}
      <Link href="/how-rankings-work" style={{ textDecoration: 'underline' }}>
        How rankings work
      </Link>
      {' · '}
      <Link href="/about" style={{ textDecoration: 'underline' }}>
        About Shipzy
      </Link>
    </p>
  );
}
